import { initScrollSnapSlider } from './scroll_snap_slider'

const COMPANY_ARCHIVE_SECTION_SLIDER_OPTIONS = {
  rootSelector: '[data-company-archive-section-slider]',
  trackSelector: '[data-company-archive-slider-track]',
  prevSelector: '[data-company-archive-slider-prev]',
  nextSelector: '[data-company-archive-slider-next]',
  initializedDataKey: 'companyArchiveSectionSliderInitialized',
}

export function initCompanyArchiveSectionSlider(root = document) {
  initScrollSnapSlider(root, COMPANY_ARCHIVE_SECTION_SLIDER_OPTIONS)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initCompanyArchiveSectionSlider())
} else {
  initCompanyArchiveSectionSlider()
}
